import { animationTransition } from '@shared/utils/animationTransition';
import { styled } from '@withjoy/joykit';

export const StyledCustomCashItemTile = styled.div`
  width: 100%;
  padding-bottom: 100%;
  position: relative;
  background-color: ${props => props.theme.colors.mono1};
  margin-bottom: 16px;
  border-radius: 4px;
  overflow: hidden;
  :hover {
    cursor: pointer;
  }
`;

const imageUrl = 'https://withjoy.com/assets/public/apps/registry/palm-tree.svg';

export const InnerBox = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: ${`url(${imageUrl})`};
  background-repeat: no-repeat;
  background-size: 95%;
  background-position: center center;
  transition: ${animationTransition('transform')};
  :hover {
    transform: scale(1.1);
    > div > svg > path {
      fill: ${props => props.theme.colors.linkHover} !important;
    }
  }
`;
